import { useTranslation } from "react-i18next";
import { ContactForm, ContentPanel, EmailIcon, PageBanner, PhoneIcon, PinIcon } from "../components";
import { ContactUsBanner } from "../images";

export const ContactUs = () => {
    const { t } = useTranslation();
    const email = t('contactUs.email')

    return (
        <div>
            <PageBanner image={ContactUsBanner} title={t('contactUs.bannerTitle')} />

            <ContentPanel headerText={t('contactUs.header')}>
                <p className="mb-4 text-center md:text-center">{t('contactUs.paragraph')}</p>

                <h2 className="text-lg md:text-xl text-white my-4 text-center">
                    {t('generic.getInTouch')}
                </h2>

                <div className="flex flex-col items-center space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 w-full text-center sm:text-left md:text-center">
                        <div className="flex items-center justify-center sm:justify-start md:justify-center gap-2">
                            <EmailIcon />
                            <span>{t('generic.email')}</span>
                        </div>
                        <a
                            href={`mailto:${email}`}
                            className="text-white hover:text-gray-900 transition-colors sm:ml-2 break-all text-center md:text-center"
                        >
                            {email}
                        </a>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 w-full text-center sm:text-left md:text-center">
                        <div className="flex items-center justify-center sm:justify-start md:justify-center gap-2">
                            <PhoneIcon />
                            <span>{t('generic.phone')}</span>
                        </div>
                        <span className="sm:ml-2">{t('contactUs.phone')}</span>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 w-full text-center sm:text-left md:text-center">
                        <div className="flex items-center justify-center sm:justify-start md:justify-center gap-2">
                            <PinIcon />
                            <span>{t('generic.locations')}</span>
                        </div>
                        <span className="sm:ml-2">{t('contactUs.location')}</span>
                    </div>
                </div>

                <h2 className="text-lg md:text-xl text-white my-4 text-center">
                    {t('generic.officeHours')}
                </h2>

                <div className="mb-4 text-center">
                    <span>{t('contactUs.officeHoursLine1')}</span>
                    <br />
                    <span>{t('contactUs.officeHoursLine2')}</span>
                </div>

                <ContactForm />
            </ContentPanel>
        </div>
    )
}